import { EggLevel } from 'contexts/EggContext';
import {
  CollectionBreaker,
  CollectionEgg,
  CollectionEntity,
  CollectionEntityRaw,
  CollectionEntities,
  CollectionGribble,
  CollectionEggRaw,
  CollectionBreakerRaw,
  CollectionGribbleRaw,
} from './model';

export const collectionTransformers = {
  /**
   * Converts a generic metadata into a known collection entity
   */
  toEntity(entity: CollectionEntityRaw): CollectionEntity {
    const { collection } = entity;
    switch (collection) {
      case CollectionEntities.Eggs:
        return { type: collection, item: collectionTransformers.toEgg(entity) };
      case CollectionEntities.Duskbreakers:
        return { type: collection, item: collectionTransformers.toBreaker(entity) };
      case CollectionEntities.Gribbles:
        return { type: collection, item: collectionTransformers.toGribble(entity) };
      default:
        throw Error(`${collection} is not a valid collection type`);
    }
  },
  toEgg(entity: CollectionEggRaw): CollectionEgg {
    const egg = {
      id: entity.tokenId.value,
      image: {
        full: entity.imageUrl,
        thumbnail: entity.imageUrl,
      },
      // TODO: extract egg state from nft metadata response
      hatching: entity.hatching,
      level: entity.level as EggLevel,
    };
    return entity.pairedBreakers?.[0]
      ? {
          pairedBreaker: {
            // TODO: fix schema when more backend data is available
            paired: entity.pairedBreakers[0].tokenId !== undefined,
            breakerSrc: entity.pairedBreakers[0].imageUrl,
          },
          ...egg,
        }
      : egg;
  },
  toBreaker(entity: CollectionBreakerRaw): CollectionBreaker {
    return {
      id: entity.tokenId.value,
      image: {
        full: entity.imageUrl,
        thumbnail: entity.imageUrl,
      },
    };
  },
  toGribble(entity: CollectionGribbleRaw): CollectionGribble {
    return {
      id: entity.tokenId.value,
      image: {
        full: entity.imageUrl,
        thumbnail: entity.imageUrl,
      },
      hatchStartedAt: new Date(entity.hatchStartedAt),
      ...(entity.pairedBreakers?.[0] && {
        pairedBreaker: {
          paired: entity.pairedBreakers[0].tokenId !== undefined,
          breakerSrc: entity.pairedBreakers[0].imageUrl,
        },
      }),
    };
  },
};
